module.exports = __webpack_public_path__ + "./kit/docs/img/big-icon-var.6e3426663e4cab47507866e20500c899.svg";